import { usePracticeLogo } from '@witmetrics/data-store';
import { getEnv } from '@witmetrics/utils/env';
import { NODE_ENV } from '@witmetrics/utils/constants';
import { API } from '@/api';
import { getAuthURL, getPracticeLogoURL } from '@/api/getURL';
import { showErrorToaster } from '@/utils/toasters';
import { useAppState } from '@/providers/AppStateProvider';
import { DIALOGS } from '@/constants/dialogs';
import HeaderLogo from '@/components/HeaderLogo';
import Tooltip from '@/components/Tooltip';
import IconButton from '@/components/IconButton';
import { AddIcon } from '@/icons';
import PlatformSelector from './PlatformSelector';
import UserMenu from './UserMenu';
import Notifications from './Notifications';
import { HEADER_HEIGHT } from './constants';
import { classes } from './utils';

export default function AppHeader() {
  const { onOpenDialog } = useAppState();
  const logo = usePracticeLogo();
  const logoSrc = logo?.value ? getPracticeLogoURL(`${logo.value}`) : null;

  const handleOpenShortcuts = () => onOpenDialog(DIALOGS.SHORTCUTS);

  const handleLogout = async () => {
    try {
      await API.Users.logout();
      // @ts-ignore
      window.location = `${getAuthURL()}/login`;
    } catch (err) {
      showErrorToaster('Error logging out');
      throw err;
    }
  };

  return (
    <header className={classes.header}>
      <HeaderLogo src={logoSrc} />
      {getEnv() === NODE_ENV.TESTING && (
        <div className={classes.testingWrapper}>
          <span>This is a testing version of witMetrics.</span>
          <a
            className={classes.testingLink}
            href="https://unison.witmetrics.io/">
            Go to main site
          </a>
        </div>
      )}
      <div className={classes.spacer} />
      <Notifications className={classes.iconButton} />
      <div className={classes.addButtonWrapper}>
        <Tooltip arrow enterDelay={0} placement="bottom" title="Shortcuts">
          <IconButton
            className={classes.addButton}
            aria-label="shortcuts"
            onClick={handleOpenShortcuts}>
            <AddIcon />
          </IconButton>
        </Tooltip>
      </div>
      <div className={classes.divider} />
      <PlatformSelector />
      <div className={classes.divider} />
      <UserMenu onLogout={handleLogout} />
    </header>
  );
}

export { HEADER_HEIGHT };
